import { axiosInstance } from '~/services/fetchServiceV2';

import { useDedupeMutation } from '../common';

type TypeChangePhoneNumberParams = {
  phoneNumber: string;
  verificationCode: string;
};

type TypeChangePhoneNumberResponse = {
  code: string;
  message: string;
};

/** @description 휴대폰 번호 변경 api에 사용되는 커스텀 훅 */
export const useChangePhoneNumber = () => {
  return useDedupeMutation<TypeChangePhoneNumberParams, TypeChangePhoneNumberResponse>({
    mutationFn: (params: TypeChangePhoneNumberParams) => {
      const endpoint = '/labor-accounts/modify-phone-number';
      return axiosInstance.post(endpoint, params);
    },
  });
};
